import React from 'react';
import { Link } from 'react-router-dom';
import './ThankYouPage.scss';

export function ThankYouPage() {
  return (
    <div className="thank-you-page">
      <div className="content">
        <h1>Thank You!</h1>
        <p>Your interview signup has been received. We'll be in touch soon to confirm your time slot.</p>
        <p>If you have any questions in the meantime, please feel free to reach out to us.</p>
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
    </div>
  );
}
